import { useTranslation } from "react-i18next";
import animationData from "@src/assets/lottie/Success.json";
import Container from "@src/components/shared/Container";
import TitleAndDesc from "@src/components/shared/TitleAndDesc";
import { Button } from "@src/components/ui/button";
import { WHITEBIT_VERIFICATION_CHECK_URL } from "@src/helpers/index";
import Player from "lottie-react";

function AlmoastDone() {
  const { t } = useTranslation();

  return (
    <Container>
      <div className="py-6">
        <TitleAndDesc
          desc={t("almostDone.desc")}
          title={t("almostDone.title")}
        />
      </div>

      <div className="w-full py-6">
        <div className="flex flex-1 items-center justify-center max-md:min-h-[60vh] md:pb-10">
          <div className="mx-auto h-[220px] w-[220px] md:h-[280px] md:w-[280px]">
            <Player
              loop={false}
              autoplay={true}
              animationData={animationData}
              rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
            />
          </div>
        </div>
      </div>
      {/* {isRedirectedFromPay || !WITH_PAYUNICARD ? ( */}
      <a className="w-full" href={WHITEBIT_VERIFICATION_CHECK_URL}>
        <div
          className="w-full self-end rounded-[6px] bg-white py-8
     max-md:absolute max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:px-4"
        >
          <Button className="w-full">{t("almostDone.home")}</Button>
        </div>
      </a>
    </Container>
  );
}

export default AlmoastDone;
